<template>
  <div class="swpoll-brandingbar">
    <div class="banner" v-if="brandingImage">
      <a :href="brandingLink" target="_blank">
        <img :src="brandingImage" />
      </a>
    </div>
    <div>
      <a :href="brandingLink" target="_blank">{{ brandingName }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'BrandingHeader',
  computed: {
    ...mapState('pollGroup', ['brandingName', 'brandingImage', 'brandingLink'])
  }
};
</script>

<style scoped lang="scss">
.swpoll-brandingbar {
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  font-style: normal;
  margin: 0;
  width: 100%;
  background-color: #fff;
  color: #3274c9;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;

  .banner {
    display: inline-block;
    width: 100%;
    height: 90px;

    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
  }
}
</style>
